// Update this when relaunching the trial — everything else flows from here.
export const ASK_DATASCOPE_TRIAL_RELEASE_DATE = new Date('2026-05-05T12:00:00');
export const ASK_DATASCOPE_TRIAL_DURATION_DAYS = 52;

export const ASK_DATASCOPE_TRIAL_END_DATE = new Date(
  ASK_DATASCOPE_TRIAL_RELEASE_DATE.getTime() +
    ASK_DATASCOPE_TRIAL_DURATION_DAYS * 24 * 60 * 60 * 1000,
);

export const askDataScopeTrialModalSeenKey = (userId: number | string) =>
  `askDataScopeTrialModalSeen_${userId}`;
